var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('global-filters',{attrs:{"instance":_vm.instance}}),_c('routes',{attrs:{"instance":_vm.instance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }